import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsCollectorsRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-collectors',
	path: '/secure/ViewCollectors([!%]?[\\w]*).jspa',
	query: ['projectKey'],
};
